module.exports = __webpack_public_path__ + "img/two2Green.ccbb055c.jpg";